document.addEventListener('DOMContentLoaded', () => {
  const MediaGallery = customElements.get('media-gallery');
  if (!MediaGallery || MediaGallery.prototype.__scrollPatched) return;

  // Store the last variant change source globally
  window.__lastVariantChangeSource = null;

  MediaGallery.prototype.setActiveMedia = function patchedSetActiveMedia(mediaId) {
    let activeMedia = this.sliderGallery.querySelector(`[data-media-id="${mediaId}"]`);
    if (activeMedia?.checkVisibility() === false) {
      activeMedia = activeMedia.nextElementSibling;
    }
    if (!activeMedia) return;

    // Don't scroll if the variant change came from a bundle product
    if (window.__lastVariantChangeSource === 'bundle') {
      window.__lastVariantChangeSource = null;
      return;
    }

    // Check if the bundle builder is currently visible
    const bundleBuilder = document.querySelector('[data-product-builder="true"]');
    const bundleBuilderContainer = bundleBuilder?.closest('[data-required-variant]');
    const isBundleVisible = bundleBuilderContainer ? !bundleBuilderContainer.hidden : false;

    // If bundle builder is visible, don't scroll (user is in bundle mode)
    // If bundle builder is hidden, allow scroll (normal product browsing)
    if (isBundleVisible) {
      return;
    }

    // Bundle is not visible, so use nearest scroll behavior
    const behavior = theme?.config?.motionReduced ? 'auto' : 'smooth';
    if (typeof activeMedia.scrollIntoView === 'function') {
      activeMedia.scrollIntoView({
        block: 'nearest',
        inline: 'nearest',
        behavior: behavior ?? 'smooth'
      });
    }
  };

  MediaGallery.prototype.__scrollPatched = true;
});

// Split variant option labels with JSON-based subtexts
document.addEventListener('DOMContentLoaded', () => {
  let variantSubtexts = {};

  // Load data from window object (set via variant-subtexts-data.js)
  if (window.variantSubtextsData) {
    const data = window.variantSubtextsData;

    // Convert array format to object format
    if (Array.isArray(data)) {
      data.forEach(item => {
        if (item.product_id && item.option_value && item.subtext) {
          // Extract the base option value (before pipe if it exists)
          const optionValue = item.option_value.split('|')[0].trim();
          const key = `${item.product_id}-${optionValue}`;
          variantSubtexts[key] = item.subtext;
        }
      });
    } else {
      variantSubtexts = data;
    }
  }

  const splitVariantLabels = () => {
    // Find all variant option labels (both swatches and regular labels)
    const labels = document.querySelectorAll('.label-swatch, .color-swatch');

    // Get current product ID from the page
    const productInfo = document.querySelector('[data-product-id]');
    const productId = productInfo ? productInfo.getAttribute('data-product-id') : null;

    labels.forEach((label) => {
      // Skip if already has the split structure (check for child spans)
      if (label.querySelector('.variant-label-main')) return;

      // Get the text content (option value)
      const text = label.textContent.trim();

      // Try to match by product_id + option_value
      if (productId && text) {
        const key = `${productId}-${text}`;
        const subText = variantSubtexts[key];

        if (subText) {
          // Replace content with styled structure
          label.innerHTML = `
            <span class="variant-label-main">${text}</span>
            <span class="variant-label-sub">${subText}</span>
          `;

          // Add class to enable flex layout
          label.classList.add('variant-label-split');
        }
      }
    });
  };

  // Run initially
  splitVariantLabels();

  // Re-run when variant pickers update (using MutationObserver)
  const observer = new MutationObserver((mutations) => {
    splitVariantLabels();
  });

  // Observe the entire product form area for changes
  const productForms = document.querySelectorAll('product-form, variant-picker, variant-selects, .product-form');
  productForms.forEach(form => {
    observer.observe(form, { childList: true, subtree: true, characterData: true, characterDataOldValue: true });
  });

  // Also listen to variant change events to reapply multiple times
  document.addEventListener('change', (event) => {
    if (event.target.matches('input[type="radio"][name^="options"]') ||
        event.target.matches('input[type="radio"][name*="Staff"]')) {
      // Apply immediately
      splitVariantLabels();
      // Apply again after short delay
      setTimeout(() => splitVariantLabels(), 50);
      // Apply again after longer delay to catch late re-renders
      setTimeout(() => splitVariantLabels(), 200);
      setTimeout(() => splitVariantLabels(), 500);
    }
  });
});


// Custom styling for Wholesale menu item
(function() {
  let styled = false;

  function styleWholesaleMenuItem() {
    if (styled) return; // Only style once

    const headerNav = document.querySelector('.header__navigation');
    if (headerNav) {
      const menuItems = headerNav.querySelectorAll('a.menu__item');
      menuItems.forEach(function(item) {
        const textContent = item.textContent.trim().toUpperCase();
        if (textContent.includes('WHOLESALE')) {
          item.style.color = '#ff9900';
          item.style.fontWeight = '800';
          styled = true;
          console.log('Wholesale menu item styled!');
        }
      });
    }
  }

  // Try immediate execution
  styleWholesaleMenuItem();

  // Watch for DOM changes
  const observer = new MutationObserver(function() {
    styleWholesaleMenuItem();
    if (styled) {
      observer.disconnect(); // Stop observing once styled
    }
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also try on events as backup
  document.addEventListener('DOMContentLoaded', styleWholesaleMenuItem);
  document.addEventListener('page:loaded', styleWholesaleMenuItem);
  setTimeout(styleWholesaleMenuItem, 100);
  setTimeout(styleWholesaleMenuItem, 500);
  setTimeout(styleWholesaleMenuItem, 1000);
})();
